import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "18px",
                color: "green",
                backgroundColor: "white",
                boxShadow: "0 1px 6px #aaa"
            },
        },
        MuiIconButton: {
            root: {
                width: "10px",
                height: "10px"
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: "calc( 0.4em + (24 - 16) * (100vw - 400px) / (800 - 400) )"
            }
        },
        MuiButton: {
            containedSizeSmall: {
                fontSize: "calc( 0.4em + (24 - 16) * (100vw - 400px) / (800 - 400) )"
            }
        }
    },
});

export default theme;